import AppStyle from './AppStyle';

export default AppStyle;
